import { RouteRecordRaw } from 'vue-router'
import marketingModules from './marketing-module'

const unifiedPage = () => import('@/modules/Mfa/UnifiedPage.vue')

export const sharedMarketingRoutes: RouteRecordRaw[] = [
  {
    path: 'dashboard',
    name: 'dashboard',
    meta: {
      module: marketingModules.marketing.defaultLayoutPage,
    },
    component: unifiedPage,
  },
  {
    path: 'contacts',
    children: [
      {
        path: '',
        name: 'contacts',
        meta: {
          module: marketingModules.marketingLegacy.defaultLayoutPage,
        },
        component: unifiedPage,
      },
      {
        path: ':contactId',
        name: 'contact-dashboard',
        meta: {
          module: marketingModules.marketingLegacy.defaultLayoutPage,
        },
        component: unifiedPage,
      },
    ]
  },
  {
    path: 'contact/new',
    name: 'contact-new',
    meta: {
      module: marketingModules.marketingLegacy.defaultLayoutPage,
    },
    component: unifiedPage,
  },
  {
    path: 'custom_fields',
    name: 'custom_fields',
    meta: {
      module: marketingModules.marketingLegacy.defaultLayoutPage,
    },
    component: unifiedPage,
  },
  {
    path: 'tags',
    name: 'tags',
    meta: {
      module: marketingModules.marketingLegacy.defaultLayoutPage,
    },
    component: unifiedPage,
  },
  {
    path: 'lists',
    children: [
      {
        path: '',
        name: 'lists',
        meta: {
          module: marketingModules.marketingLegacy.defaultLayoutPage,
        },
        component: unifiedPage,
      },
      {
        path: ':listId',
        children: [
          {
            path: '',
            name: 'list-view',
            meta: {
              module: marketingModules.marketingLegacy.defaultLayoutPage,
            },
            component: unifiedPage,
          },
          {
            path: 'contacts',
            name: 'list-contacts',
            meta: {
              module: marketingModules.marketingLegacy.defaultLayoutPage,
            },
            component: unifiedPage,
          },
          {
            path: 'create_contact',
            name: 'list-contact-new',
            meta: {
              module: marketingModules.marketingLegacy.defaultLayoutPage,
            },
            component: unifiedPage,
          },
          {
            path: 'contacts/:contactId',
            name: 'list-contact-dashboard',
            meta: {
              module: marketingModules.marketingLegacy.defaultLayoutPage,
            },
            component: unifiedPage,
          },
          {
            path: "file_import",
            name: "File_import",
            meta: {
                module: marketingModules.marketingLegacy.defaultLayoutPage,
            },
              component: unifiedPage
          },
          {
              path: "ftp_import",
              name: "List_ftp_import",
              meta: {
                  module: marketingModules.marketingLegacy.defaultLayoutPage,
              },
              component: unifiedPage
          },
          {
              path: "automated_import",
              name: "List_automated_import",
              meta: {
                  module: marketingModules.marketingLegacy.defaultLayoutPage,
              },
              component: unifiedPage,
          }
        ],
      },
    ]
  },
  {
    path: 'users-&-permissions',
    name: 'users-permissions',
    meta: {
      module: marketingModules.marketingLegacy.defaultLayoutPage,
    },
    component: unifiedPage,
  },
  {
    path: 'settings',
    name: 'users-settings',
    meta: {
      module: marketingModules.marketing.defaultLayoutPage,
    },
    component: unifiedPage,
  },
  {
    path: 'account-&-billing',
    name: 'account-&-billing',
    meta: {
      module: marketingModules.marketingLegacy.defaultLayoutPage,
    },
    component: unifiedPage,
    children: [
      {
        path: "",
        name: "Account_settings_overview",
        component: ()=>import('@/lib/layouts/DefaultLayout.vue'),
       },
      
      {
        path: "company-information",
        name: "Account_settings_account",
        component: ()=>import('@/lib/layouts/DefaultLayout.vue'),
      },
      {
        path: "usage",
        name: "Account_usage",
        component: ()=>import('@/lib/layouts/DefaultLayout.vue'),
      },
      {
        path: "subscriptions",
        name: "Account_subscription",
        component: ()=>import('@/lib/layouts/DefaultLayout.vue'),
      },
      {
        path: "requests",
        name: "Account_subscription_requests",
        component: ()=>import('@/lib/layouts/DefaultLayout.vue'),
      },
    ]
  },
]
